import { render, staticRenderFns } from "./TipoAssinatura.vue?vue&type=template&id=1fdae163"
import script from "./TipoAssinatura.vue?vue&type=script&lang=js"
export * from "./TipoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./TipoAssinatura.vue?vue&type=style&index=0&id=1fdae163&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports